import { space } from '../tokens';
import { style } from '../layer.css';

export const toastAction = style({
  margin: -space.s6,
});
